import { render, staticRenderFns } from "./GameInProgress.vue?vue&type=template&id=44df2091"
import script from "./GameInProgress.vue?vue&type=script&lang=js"
export * from "./GameInProgress.vue?vue&type=script&lang=js"
import style0 from "./GameInProgress.vue?vue&type=style&index=0&id=44df2091&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports